import React, { Component } from "react";
import App from "../../App";
import {Button, Col, Form, Row} from "react-bootstrap";
import {Link, withRouter} from "react-router-dom";
import {toast} from "react-toastify";
import {getCategory} from "../../services/categoryServices";
import {getData, serialiseAndPost} from "../../services/baseServices";
import ChooseCategory from "../../components/ChooseCategory";
import BrowseButton from "../../components/BrowseButton";
import { FaLongArrowAltLeft } from "react-icons/all";
import { convertToSlug } from "../../helper/utils";
import MetaInfo from '../../components/MetaInfo'


class Add extends Component {
  constructor() {
    super();
    this.state = {
      categories: [],
      formData: { image_file: "", banner_image_file: "", slug: '' },
      isFormValidated: false,
      isLoadingData: true,
      isSubmitting: false,
      selectedFile: null,
      parent_ids: [],
      metaInfo:{},
      uniqueSlug: ''
    };
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      formData
    } = this.state
    console.log(prevState)
    if (prevState.formData?.slug !== formData?.slug) {
        if(formData?.slug) {
            getData('slugs/uniqueness', {slug: formData.slug, type: "Category"})
            .then(res => this.setState({uniqueSlug: res.success}))
            .catch(err => this.setState({uniqueSlug: ''}))
        } else {
            this.setState({uniqueSlug: ''})
        }
    }
  }

  componentDidMount() {
    getCategory()
      .then((res) => {
        let categories = this.getSubcat(res.categories, []);
        this.setState({ categories: categories });
      })
      .catch((errMsg) => {
        console.log("Err Msg: ", errMsg);
      });
  }

  handleInputOnChange = (e) => {
    const formData = { ...this.state.formData };
    if(e.target.name === 'title') {
      const slug = convertToSlug( e.target.value)
      formData['slug'] = slug
      formData[e.target.name] = e.target.value;
    }else if(e.target.name === 'slug') {
      const slug = convertToSlug(e.target.value)
      formData['slug'] = slug;
    }else{
      formData[e.target.name] = e.target.value;
    }
    this.setState({ formData }, () => {
      console.log(this.state.formData);
    });
    
  };

  getSubcat = (category, categories) => {
    let cat = categories;
    category.forEach((item) => {
      cat.push(item);
      if (item?.sub_categories?.length > 0) {
        this.getSubcat(item?.sub_categories, categories);
      }
    });
    return cat;
  };

  handleOnMetaInputChange = (e) =>{
    const metainfo = {...this.state.metaInfo}
    const name = e.target.name;
    const value = e.target.value;
    const updatedMetaInfo = {...metainfo, [name]:value}
    this.setState({metaInfo:updatedMetaInfo})   
  }
  handleOnChangeKeywordValue = (en_bn, value) => {
    const mitainfoDetails = {...this.state.metaInfo};
    const valueIdArr = [];
    if (value?.length > 0) {
      value.forEach(val => {
        valueIdArr.push(val.value);
      })
    }
    if (en_bn === 'en') {
        mitainfoDetails.metaKeywords = valueIdArr;
    } else {
        mitainfoDetails.metaKeyKeywordsBn = valueIdArr;
    }
    this.setState({metaInfo:mitainfoDetails})   
  }

  handleAddCategory = (e) => {
    e.preventDefault();
    const formInfo = {...this.state.formData}
    const metaData= {...this.state.metaInfo}
    const meta_datum_attributes = {
        meta_title: metaData.metaTitle,
        bn_meta_title: metaData.metaTitleBn, 
        meta_description: metaData.metaDescription, 
        bn_meta_description: metaData.metaDescriptionBn,
        meta_keyword: metaData.metaKeywords,
        bn_meta_keyword: metaData.metaKeyKeywordsBn
        }
    const updatedFormInfo = {...formInfo, meta_datum_attributes}
    this.setState({formData:updatedFormInfo})

    const form = e.currentTarget;

    if (form.checkValidity() === false) {
      e.preventDefault();
      e.stopPropagation();
      this.setState({ isFormValidated: true });
    } else {
      this.setState({ isSubmitting: true }, () => {
        const formData = { ...this.state.formData };
        formData.home_page_visibility = 1;

        if(!formData.image_file || !formData.banner_image_file) {
          toast.error("Please Choose an Image and a Banner")
          this.setState({isSubmitting: false})
        } else {
          formData.parent_id = this.state.parent_ids.slice(-1)[0];
          serialiseAndPost('categories','category',formData)
            .then(res => {
              if(res?.id) {
                this.props.history.push(`/category/list`);
                toast.success("Category has been added successfully.");
              } else {
                toast.error(res?.message);
                this.setState({isSubmitting: false})
              }
            })
            .catch((errMsg) => {
              toast.error(errMsg);
              this.setState({ isSubmitting: false });
            });
        }
        if (!formData.image_file) {
          delete formData.image_file;
        }
        if (!formData.banner_image_file) {
          delete formData.banner_image_file;
        }
      });
    }
  };

  onFileChange = (event, name) => {
    const formData = { ...this.state.formData };
    formData[name] = event.target.files[0];
    this.setState({formData });
  };

  render() {
    console.log('category meta info', this.state.metaInfo);
    return (
      <App layout="boxed">
        <div className="page-header">
          <h2 className="page-title">Add Category</h2>
          <div className="ml-auto">
            <Link
              to={`${process.env.PUBLIC_URL}/category/list`}
              className="btn btn-sm btn-link"
            >
              <FaLongArrowAltLeft /> Back to Category List
            </Link>
          </div>
        </div>
        <Form
          noValidate
          validated={this.state.isFormValidated}
          onSubmit={this.handleAddCategory}
        >
        <div className="card-block">
          <div className="block-header">
                <h4 className="block-title">Basic Info</h4>
            </div>
          <div className="block-body">
            <Form.Group as={Row} controlId="business_type">
              <Form.Label column sm="3">
              Business Type <span className="text-danger">*</span>
              </Form.Label>
              <Col sm="9" md={8} lg={7}>
              <Form.Check
                  custom
                  inline
                  type="radio"
                  name="business_type"
                  id={`custom-radio-1`}
                  required
                  onChange={this.handleInputOnChange}
                  value={'b2c'}
                  label={`B2C`}
              />
              <Form.Check
                  custom
                  inline
                  type="radio"
                  name="business_type"
                  required
                  onChange={this.handleInputOnChange}
                  value={'b2b'}
                  id={`custom-radio-4`}
                  label={`B2B`}
              />
              <Form.Check
                  custom
                  inline
                  type="radio"
                  name="business_type"
                  required
                  onChange={this.handleInputOnChange}
                  value={'both'}
                  id={`custom-radio-2`}
                  label={`Both(B2B and B2C)`}
              />

              <Form.Control.Feedback type="invalid">
                  Please select a Business type.
              </Form.Control.Feedback>
              </Col>
          </Form.Group>
                <Form.Group as={Row} controlId="displayOrShopName">
                  <Form.Label column sm="3">
                    Title in English <span className="text-danger">*</span>
                  </Form.Label>
                  <Col sm="9" md={8} lg={7}>
                    <Form.Control
                      name={"title"}
                      onChange={this.handleInputOnChange}
                      required
                      type="text"
                    />

                    <Form.Control.Feedback type="invalid">
                      Please enter category.
                    </Form.Control.Feedback>
                  </Col>
                </Form.Group>

                <Form.Group as={Row} controlId="formName">
                    <Form.Label column sm="3">
                        Slug <span className="text-danger">*</span>
                    </Form.Label>
                    <Col sm="9" md={8} lg={7}>
                        <Form.Control type="text"
                                        required
                                        value={this.state.formData?.slug}
                                        onChange={this.handleInputOnChange}
                                        name="slug"/>
                      <Form.Control.Feedback type="invalid">
                      Please enter slug.
                    </Form.Control.Feedback>
                    {this.state.uniqueSlug === false && <div class="slug-err-msg">Please provide an unique slug.</div>}
                    </Col>
                </Form.Group>
                <Form.Group as={Row} controlId="displayOrShopName">
                  <Form.Label column sm="3">
                    Title in Bangla <span className="text-danger">*</span>
                  </Form.Label>
                  <Col sm="9" md={8} lg={7}>
                    <Form.Control
                      name={"bn_title"}
                      onChange={this.handleInputOnChange}
                      required
                      type="text"
                    />

                    <Form.Control.Feedback type="invalid">
                      Please enter category in bangla.
                    </Form.Control.Feedback>
                  </Col>
                </Form.Group>

                <Form.Group as={Row} controlId="formCategory">
                  <Form.Label column sm="3">
                    Parent Category
                  </Form.Label>
                  <Col sm="9" md={8} lg={7}>
                    <ChooseCategory
                      onConfirm={async (attr) => {
                        let catArr = [];
                        await attr.map((item) => {
                          catArr.push(item.id);
                        });
                        this.setState({ parent_ids: catArr }, () => {
                          console.log(this.state.parent_ids);
                        });
                      }}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row} controlId="position">
                  <Form.Label column sm="3">
                    Position <span className="text-danger">*</span>
                  </Form.Label>
                  <Col sm="9" md={8} lg={7}>
                    <Form.Control
                      required
                      name={"position"}
                      onChange={this.handleInputOnChange}
                      min={0}
                      pattern="\d*"
                      type="number"
                    />

                    <Form.Control.Feedback type="invalid">
                      Please enter position to show in ecom.
                    </Form.Control.Feedback>
                  </Col>
                </Form.Group>
                <Form.Group as={Row} controlId="displayOrShopName">
                  <Form.Label column sm="3">
                    Image<span className="text-danger">*</span>
                  </Form.Label>
                  <Col sm="9" md={8} lg={7}>
                    <BrowseButton
                      id={"image_file"}
                      name={"image_file"}
                      onChange={(e)=>this.onFileChange(e, "image_file")}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row} controlId="banner_image_file">
                  <Form.Label column sm="3">
                    Banner Image<span className="text-danger">*</span>
                  </Form.Label>
                  <Col sm="9" md={8} lg={7}>
                    <BrowseButton
                      id={"banner_image_file"}
                      name={"banner_image_file"}
                      onChange={(e)=>this.onFileChange(e, "banner_image_file")}
                    />
                  </Col>
                </Form.Group>
          </div>
        </div>
        <div className="card-block">
          <div className="block-header">
                <h4 className="block-title">Meta Info</h4>
          </div>
          <div className="block-body">
          <MetaInfo 
              metaInfo={this.state.metaInfo} 
              handleOnInputChange={this.handleOnMetaInputChange} 
              handleOnChangeKeywordValue= {this.handleOnChangeKeywordValue}
              />          
            </div>
        </div>
        <div className="mt-3 text-right">
            <Button
              size="lg"
              type={`submit`}
              disabled={this.state.isSubmitting || this.state.uniqueSlug === false}
              variant="primary"
            >
              {this.state.isSubmitting ? "Submitting..." : "Submit"}
            </Button>
          </div>
        </Form>
      </App>
    );
  }
}

export default withRouter(Add);
